import { Component } from "@angular/core";
import { BaseModal } from "@app/shared/cerrix-modal/BaseModal";
import { EntityModel } from "@app/datamanagement/models/EntityModel";
import { NgSelectModule } from "@ng-select/ng-select";

@Component({
    selector: "entity-dialog",
    templateUrl: "./entity-dialog.component.html",
    styleUrls: ["./entity-dialog.component.scss", "../../../../sass/datamanagement.scss"],
    imports: [NgSelectModule],
})
export class EntityDialogComponent extends BaseModal {
    entities: EntityModel[];

    changed(currentSelection: EntityModel[]) {
        const currentSelectedIds = currentSelection.map((x) => x.id);
        this.entities.forEach((x) => {
            x.selected = currentSelectedIds.indexOf(x.id) > -1;
        });
    }

    okClick() {
        this._bsModalRef.hide();

        super.onConfirm(this.entities.filter((x) => x.selected));
    }

    closeClick() {
        super.onCancel();
    }
}
